import {
    getCarBodyTypeRequest,
    getCarCharacteristicRequest,
    getCarGenerationRequest,
    getCarMarkRequest,
    getCarModelRequest,
    getCarModificationRequest,
    getCarTechDataRequest,
    getCarTypeRequest,
} from '../../../services/network/fields/car';

class CarDataFieldsService {
    async getCarType() {
        return await getCarTypeRequest();
    }

    async getCarMark(type) {
        return await getCarMarkRequest(type);
    }

    async getCarModel(mark) {
        return await getCarModelRequest(mark);
    }

    async getCarGeneration(params) {
        return await getCarGenerationRequest(params);
    }

    async getCarBodyType(params) {
        return await getCarBodyTypeRequest(params);
    }

    async getCarModification(params) {
        return await getCarModificationRequest(params);
    }

    async getCarCharacteristic(params) {
        return await getCarCharacteristicRequest(params);
    }

    async getCarTechData(params) {
        return await getCarTechDataRequest(params);
    }
}

export const CarDataLadderSearchService = new CarDataFieldsService();
